// Module
var code = "<div class=row> <div class=col-lg-6> <unit-converter></unit-converter> <cli-mappings></cli-mappings> <keys-pipeline></keys-pipeline> <ec-recover></ec-recover> </div> <div class=col-lg-6> <hashes></hashes> <address-formatter></address-formatter> <hex></hex> <evm-words></evm-words> </div> </div> ";
// Exports
module.exports = code;